module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01_m_en.4ad2f4fc51b05be9df227950d79cfe56.png";